/**
 * Liste des pays disponibles pour la recherche de recettes
 * nameKey = clé de traduction dans LanguageContext
 */
export const countries = [
  { code: "", nameKey: "countryAll" },
  { code: "American", nameKey: "countryAmerican" },
  { code: "British", nameKey: "countryBritish" },
  { code: "Cambodian", nameKey: "countryCambodian" },
  { code: "Canadian", nameKey: "countryCanadian" },
  { code: "Chinese", nameKey: "countryChinese" },
  { code: "French", nameKey: "countryFrench" },
  { code: "Greek", nameKey: "countryGreek" },
  { code: "Indian", nameKey: "countryIndian" },
  { code: "Italian", nameKey: "countryItalian" },
  { code: "Japanese", nameKey: "countryJapanese" },
  { code: "Mexican", nameKey: "countryMexican" },
  { code: "Moroccan", nameKey: "countryMoroccan" },
  { code: "Spanish", nameKey: "countrySpanish" },
  { code: "Turkish", nameKey: "countryTurkish" },
  { code: "Vietnamese", nameKey: "countryVietnamese" },
];
